import React from 'react'

import { AuthorImage, Size as ImageSize } from './AuthorImage/AuthorImage'
import {
  Container,
  DetailsContainer,
  AuthorImageContainer,
  AuthorName,
} from './style'
import { BlockAttributes } from '../BlockAttributes'

type Attributes = string[]

export interface AuthorDetailsProps {
  readonly article: {
    date: Date
    author: {
      name: string
      title: string
      profileUri: string
      imageUrl?: string
      imageAlt: string
    }
  }
  readonly additionalAttributes?: Attributes
  readonly isAmp?: boolean
  readonly imageSizes?: ImageSize[]
}

export const AuthorDetails = ({
  article: { author },
  additionalAttributes,
  isAmp,
  imageSizes = ['small'],
}: AuthorDetailsProps) => {
  return (
    <Container onClick={() => window.location.assign(author.profileUri)}>
      <DetailsContainer>
        <AuthorName href={author.profileUri}>{author.name}</AuthorName>
        <BlockAttributes
          attributes={[author.title, ...(additionalAttributes ?? [])]}
        />
      </DetailsContainer>
      <AuthorImageContainer href={author.profileUri}>
        <AuthorImage
          authorName={author.name}
          url={author.imageUrl}
          alt={author.imageAlt}
          isAmp={isAmp}
          sizes={imageSizes}
          lazyImage={true}
        />
      </AuthorImageContainer>
    </Container>
  )
}
